/**
 * Parsing for the price filter's Από / Έως fields. Greek shoppers type a decimal
 * comma, and a number input would reject it or read it by the device's locale,
 * so the fields are plain text and parsed here.
 */

/** Empty → undefined (no limit). Not a price → null (the field reverts). */
export function parsePriceInput(raw: string): number | undefined | null {
  const text = raw.replace(/€|\s/g, '').replace(',', '.');
  if (text === '') return undefined;
  if (!/^\d+(\.\d+)?$/.test(text)) return null;
  return Number(text);
}

/** "From 30 to 15" is a typing slip, not an empty result. */
export function orderPriceRange(
  min: number | undefined,
  max: number | undefined,
): [number | undefined, number | undefined] {
  return min !== undefined && max !== undefined && min > max ? [max, min] : [min, max];
}
